import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/invite_relationship_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  name_cont: {
    model_name: 'InviteRelationship',
    column_type: 'string',
    column_name: 'name',
  },
  phone_cont: {
    model_name: 'InviteRelationship',
    column_type: 'string',
    column_name: 'phone',
  },
  remark_cont: {
    model_name: 'InviteRelationship',
    column_type: 'string',
    column_name: 'remark',
  },
  parent_id_eq: {
    column_type: 'belongs_to',
    column_name: 'parent',
    extra: {
      model_name: 'InviteRelationship',
    },
    model_name: 'InviteRelationship',
  },
  parent: {
    column_type: 'belongs_to',
    column_name: 'parent',
    extra: {
      model_name: 'InviteRelationship',
    },
    model_name: 'InviteRelationship',
  },
  user_id_eq: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
    },
    model_name: 'InviteRelationship',
  },
  user: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
    },
    model_name: 'InviteRelationship',
  },
}
export const formColumnsConfig = {
  'self': {
    'name': { required: true, disabledUpdate: false },
    'phone': { required: true, disabledUpdate: false },
    'parent_id': { required: false, disabledUpdate: false },
    'user_id': { required: false, disabledUpdate: false },
    'remark': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return entityColumnsExtend(shareColumnsExtend('InviteRelationship', columns), { filterColumnsExtend })
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('InviteRelationship', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
